import React, { Component } from 'react';
import ContentCard from '../common/ContentCard';
import { PropTypes } from 'prop-types';
import * as Sentry from '@sentry/react';

/**
 * This is an error boundary for handling any errors in the app
 *
 * @see https://npm.im/react-error-boundary
 */
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        console.log('error', error);
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    tryAgain() {
        this.setState({
            hasError: false,
        });
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log(error, errorInfo);
        Sentry.captureException(error);
    }

    render() {
        const mainContent = (
            <div>
                <p>Something went wrong.</p>
                <button
                    className="btn btn-primary"
                    onClick={this.tryAgain.bind(this)}
                >
                    try again
                </button>
            </div>
        );

        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <ContentCard content={mainContent} />;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    // components/rendereable to be rendered inside on 'retry'
    children: PropTypes.node,
};

export default ErrorBoundary;
